import { EllipsisText, type GridColDef } from '@shared/components';

import { type ExamEventOverviewReportItem } from './types';

export const columns: GridColDef<ExamEventOverviewReportItem>[] = [
  {
    field: 'startedAt',
    headerName: 'Exam Date',
    sortable: false,
    width: 106,
  },
  {
    field: 'examTime',
    headerName: 'Time',
    width: 116,
    sortable: false,
  },
  {
    field: 'examCenterCode',
    headerName: 'Exam Center',
    minWidth: 116,
    sortable: false,
    renderCell: (params) => <EllipsisText>{params.row.examCenterCode}</EllipsisText>,
  },
  {
    field: 'regType',
    headerName: 'Reg Type',
    width: 89,
    sortable: false,
  },
  {
    field: 'province',
    headerName: 'Province',
    sortable: false,
    width: 142,
    renderCell: (params) => <EllipsisText>{params.row.province}</EllipsisText>,
  },
  {
    field: 'location',
    headerName: 'Location',
    sortable: false,
    flex: 1,
    minWidth: 282,
    renderCell: (params) => <EllipsisText>{params.row.location}</EllipsisText>,
  },
  {
    field: 'examType',
    headerName: 'Exam Type',
    sortable: false,
    minWidth: 101,
  },
  {
    field: 'totalSeats',
    headerName: 'Total Seats',
    width: 104,
    sortable: false,
    type: 'number',
  },
  {
    field: 'registeredSeats',
    headerName: 'Registered',
    sortable: false,
    width: 104,
    type: 'number',
  },
  {
    field: 'attendedSeats',
    headerName: 'Attended',
    sortable: false,
    width: 104,
    type: 'number',
  },
];
